export const renderCell = (col: any) => {
  if (col.render) {
    return {
      ...col,
      onCell: (record: any) => ({
        ...col,
        record,
        title: col.title,
        dataIndex: col.dataIndex,
        shouldRender: true,
      }),
    }
  }

  return {
    ...col,
    onCell: (record: any) => ({
      record,
      title: col.title,
      type: col.type || 'text',
      dataIndex: col.dataIndex,
      ...col.format,
    }),
  }
}
